// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-overlay[data-v-7d95196a]{background:hsla(0,0%,100%,.9);padding-top:150px}.loading-overlay[data-v-7d95196a] .inner-circle{border-width:6px}.body-copy[data-v-7d95196a] p{color:rgba(0,0,0,0.6)}.body-copy[data-v-7d95196a] a{text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
